// Toont een duidelijke banner wanneer de app als STAGING-build is gebouwd.
// De vlag REACT_APP_ENV=staging wordt door deploy-staging.sh bij de build gezet;
// productie bouwt zonder die vlag, dus daar verschijnt niets.
import { useLayoutEffect, useRef } from 'react';

const IS_STAGING = process.env.REACT_APP_ENV === 'staging';

export default function StagingBanner() {
  const ref = useRef(null);

  // Hoogte als --banner-h, zodat de sidebar en sticky paginakoppen eronder schuiven
  useLayoutEffect(() => {
    if (!IS_STAGING || !ref.current) return;
    const root = document.documentElement;
    const update = () => root.style.setProperty('--banner-h', `${ref.current.offsetHeight}px`);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(ref.current);
    return () => { ro.disconnect(); root.style.removeProperty('--banner-h'); };
  }, []);

  if (!IS_STAGING) return null;
  return (
    <div
      ref={ref}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 2000,
        background:
          'repeating-linear-gradient(45deg,#b45309,#b45309 14px,#92400e 14px,#92400e 28px)',
        color: '#fff',
        textAlign: 'center',
        fontWeight: 700,
        letterSpacing: '0.4px',
        padding: '5px 10px',
        fontSize: '13px',
        boxShadow: '0 1px 4px rgba(0,0,0,.25)',
      }}
    >
      ⚠ STAGING — testomgeving (geen productiedata)
    </div>
  );
}
